import React from "react";

import Table from "../table/table";
import { getCountryData } from "../../service/countryCountData";
import {
  getCountryTableTitle,
  getCountryTableHeaders,
  getCountryTableDisclaimer,
} from "../../service/textRetrieval";
import { useInterval } from "../../util/useInterval";
import {
  addThousandSeparators,
  matchDecimalPlaces,
  removeMissingFields,
  addPercentSymbol
} from "../../util/parseTableData";

import CountryTableStyle from "./countryTable.module.css";

const CountryTable = ({ textLiterals, variant = "ukvui" }) => {
  const [isLoading, setIsLoading] = React.useState(true);

  const [data, setData] = React.useState([]);
  const [title, setTitle] = React.useState("");
  const columns = React.useRef([]);
  const [disclaimer, setDisclaimer] = React.useState("");

  const fieldToAddCommas = React.useRef(["total", "numvui_last4wks"]);
  const fieldToFixDp = React.useRef(["percvui_last4wks"]);
  const fieldToAddPerc = React.useRef(["percvui_last4wks"]);
  const updateData = React.useCallback((data) => {
    setIsLoading(false);
    setData(
      addPercentSymbol(matchDecimalPlaces(
        addThousandSeparators(
          removeMissingFields(data),
          fieldToAddCommas.current
        ),
        fieldToFixDp.current,
        1
      ),fieldToAddPerc.current)
    );
  }, []);

  React.useEffect(() => {
    setIsLoading(true);
    setTitle(getCountryTableTitle(textLiterals));
    columns.current = getCountryTableHeaders(variant, textLiterals);
    setDisclaimer(getCountryTableDisclaimer(textLiterals));
    getCountryData(variant).then((result) => {
      updateData(result);
      setIsLoading(false);
    });
  }, [variant, updateData, textLiterals]);

  const fiveMinutes = 1000 * 60 * 5; // in milliseconds
  useInterval(() => {
    getCountryData(variant).then((result) => updateData(result));
  }, fiveMinutes);

  return (
    <div className={`${CountryTableStyle.fullWidth} `}>
      <h2 className={CountryTableStyle.title}>
        {title ?? "Country Submission Count"}
      </h2>
      <Table
        columns={columns.current}
        data={data}
        isLoading={isLoading}
        downloadFileName="countrySubmissionCount.csv"
        disclaimer={disclaimer}
      />
    </div>
  );
};

export default CountryTable;
